import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const parseMessageWithLinks = text => {
  if (React.isValidElement(text)) {
    return text;
  }

  if (typeof text !== 'string') {
    return text;
  }

  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    if (part.match(urlRegex)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className={cn('tw-underline', {
            'tw-text-mainOrange': true,
          })}
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

const ChatBubble = ({ isReceived, message, isExpanded }) => (
  <p
    className={cn(
      'tutor-message !tw-mb-4 tw-w-fit tw-rounded-b-[10px] tw-px-4 tw-py-3 tw-text-sm',
      {
        'tw-rounded-tl-[2px] tw-rounded-tr-[10px] tw-bg-gray-400': isReceived,
        'tw-ml-auto tw-rounded-tl-[10px] tw-rounded-tr-[2px] tw-bg-mainOrange tw-text-white':
          !isReceived,
        'tw-max-w-[270px]': !isExpanded,
        'tw-max-w-[80%]': isExpanded,
      },
    )}
  >
    {parseMessageWithLinks(message)}
  </p>
);

ChatBubble.propTypes = {
  isReceived: PropTypes.bool.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  isExpanded: PropTypes.bool,
};

ChatBubble.defaultProps = {
  message: '',
  isExpanded: false,
};

export default ChatBubble;
